
import { defineComponent } from 'vue';
import { ActionTypes } from '@/store/actionTypes';

export default defineComponent({
    data(): {
        refreshClicked: boolean;
    } {
        return {
            refreshClicked: false,
        };
    },
    props: {
        parentRefreshing: Boolean,
    },
    methods: {
        async refresh() {
            this.refreshClicked = true;
            await this.$store.dispatch(ActionTypes.REFRESH_TRUCK, undefined);
        },
    },
    watch: {
        parentRefreshing(val) {
            if (!val && this.refreshClicked) this.refreshClicked = false;
        },
    },
});
